const Vue = window.Vue

Vue.component("CytCarousel", () => import("./app/components/carousel/CytCarousel.vue"))
